const INFO = {
	main: {
		title: "Portofolio",
		name: "Faisal Ali Muhamad",
		email: "faisalali2858@gmail.com",
		logo: "../logo_new.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/faisalalm01",
		linkedin: "https://linkedin.com/in/faisal-ali-muhamad-0135b8212/",
		instagram: "https://instagram.com/faisalalm28",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-stack web and mobile app developer, and relaxed rider.",
		description:
			"I am a software engineer with experience in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Faisal Ali M. I live in Indonesia, where I look for opportunities.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Jejak Rempah Market Place (JRM)",
			description:
				"JRM (Jejak Rempah Marketplace) is a website for selling buy spices in Indonesia. with users who can Choose to buy or create the store you want to go to according to with spice knot points available. This project related to the virtual tour of the spice trail trail.",
			image: "project/Faisal Ali Muhamad.png",
			linkText: "View Project",
			link: "https://github.com/faisalalm01",
		},

		{
			title: "Zavis Voucher - PT. Sekawan Media",
			description:
				"Zavis Voucher is a mobile application for lending in the form of vouchers for shopping. This project is a Semester 7 internship project which is carried out at P.T. Sekawan Media in the city of Malang, East Java.",
			image: "project/Faisal Ali Muhamad (1).png",
			linkText: "View Project",
			link: "https://github.com/faisalalm01",
		},

		{
			title: "Syngenta Seedtrack - PT. Sekawan Media",
			description:
				"The Syngenta Seedtrack portal is a website application for reporting, tracking, and seed harvesting. This project is a Semester 7 internship project which is carried out at P.T. Sekawan Media in the city of Malang, East Java.",
			image: "project/Faisal Ali Muhamad (2).png",
			linkText: "View Project",
			link: "https://github.com/faisalalm01",
		},

		{
			title: "Crime Detection - Tugas Akhir (Skripsi)",
			description:
				"Crime detection is a mobile application to detect types of crimes through CCTV cameras. This project is a final project (thesis) that is done for the research I made.",
			image: "project/Faisal Ali Muhamad (3).png",
			linkText: "View Project",
			link: "https://github.com/faisalalm01",
		},

		{
			title: "Kuesioner Website - Politeknik Harapan Bersama",
			description:
				"Website Questionnaire is a website application for SPMI in managing reports and questionnaires that will be filled out by students. This project is an internship project carried out at the Harapan Bersama Polytechnic in Tegal, Central Java.",
			image: "project/Faisal Ali Muhamad (4).png",
			linkText: "View Project",
			link: "https://github.com/faisalalm01",
		},

		{
			title: "To Do List App",
			description:
				" To Do List App is a website application for SPMI in managing reports and questionnaires that will be filled out by students. This project is an internship project carried out at the Harapan Bersama Polytechnic in Tegal, Central Java.",
			image: "project/Faisal Ali Muhamad (5).png",
			linkText: "View Project",
			link: "https://github.com/faisalalm01",
		},
	],
};

export default INFO;
